import { z } from "zod/v4";

export const createNewMemberSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.email().min(1, "Email is required"),
  mailListIds: z.array(z.number()),
});

export type CreateNewMemberSchemaValues = z.infer<typeof createNewMemberSchema>;
